/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Seo_DescriptionInputs */

const cs_blog_seo_description = /** @type {(inputs: Blog_Seo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO popis`)
};

const en_blog_seo_description = /** @type {(inputs: Blog_Seo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO description`)
};

/**
* | output |
* | --- |
* | "SEO description" |
*
* @param {Blog_Seo_DescriptionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_seo_description = /** @type {((inputs?: Blog_Seo_DescriptionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Seo_DescriptionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_seo_description(inputs)
	return cs_blog_seo_description(inputs)
});